import {
	createActionsHook,
	type BoundActions,
	type HookActionsFunction,
	type StoreActionApi,
} from 'react-sweet-state';

import type { RovoChatInitiator } from './RovoChatInitiator';
import { store } from './store';

export const useChatInitiatorStoreActions: HookActionsFunction<
	BoundActions<
		RovoChatInitiator,
		{
			initChatInitiator: (
				initiator?: string,
			) => ({ setState, getState }: StoreActionApi<RovoChatInitiator>) => void;
			getChatInitiator: () => ({ getState }: StoreActionApi<RovoChatInitiator>) => string;
		}
	>
> = createActionsHook(store);
